var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContraxLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#91233B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New_Layer"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M505,43.14c-73.53,37.14-184.58,93.29-313.26,158.19C32.8,281.49,32.92,281.37,32.55,284.49 c-1,6.5-15.13,6.13,271.37,6.13h267.37v-30.64v-30.64h-80.03c-78.41,0-80.03,0-82.54-2.5c-2.38-2.38-2.5-4.13-2.5-33.01 c0-30.01,0-30.64,2.88-33.76c1.5-1.63,38.52-21.01,82.16-43.14l79.41-40.02l0.38-33.14c0.13-18.38-0.13-33.26-0.63-33.26 C569.78,10.5,540.39,25.26,505,43.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.92,311.38c-0.38,1.13-0.25,3,0.5,4.13c0.63,1,37.14,21.63,81.16,45.77l79.91,43.77l92.16,0.63 c86.29,0.63,92.29,0.75,94.42,2.88c2,2,2.25,6,2.88,42.77c0.38,24.64,1.13,41.02,1.88,41.64c1.75,1.63,81.91,42.27,85.41,43.27 l2.75,0.88v-60.78c0-54.27,0.25-61.03,2-63.9c4.38-6.63,5.5-6.75,54.27-6.75h45.02v-48.15v-48.15H300.54 C50.93,309.38,29.67,309.5,28.92,311.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M490.87,427.81c-0.5,0.38-0.88,27.39-0.88,59.78c0,54.65,0.13,59.15,2.25,60.9 c1.13,1.13,19.38,10.75,40.64,21.51l38.39,19.51v-81.29v-81.29h-39.77C509.63,426.93,491.25,427.3,490.87,427.81z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "MasterLayer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContraxLogo);
export default __webpack_public_path__ + "static/media/contrax_logo.4a3fe502a0876630d4f2c92b8ed33072.svg";
export { ForwardRef as ReactComponent };